// extracted by mini-css-extract-plugin
export default {"infoText":"PBRufx"};